import { observable } from "mobx";
import { Expose } from "class-transformer";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class ReqOnlinePayment {
  /**
   * Enumeration::GatewayMethod
   */
  @observable
  @Expose({ name: "gateway_method_id" })
  gatewayMethodId!: number;

  static ValidationRules = {
    gatewayMethodId: { required: true, number: true },
  };
}
